/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the software.

*/

import React from "react";
import { createRoot} from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Vision UI Dashboard React Context Provider
import { VisionUIControllerProvider } from "context";

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { http, createConfig, WagmiProvider } from 'wagmi'
import { base } from 'wagmi/chains'

import { WalletProvider } from "WalletProvider";
import { RainbowKitProvider } from "@rainbow-me/rainbowkit";
import { ConnectKitProvider, getDefaultConfig } from "connectkit";
import { injected } from "wagmi/connectors";
import { ToastContainer } from "react-toastify";
import { SpeedInsights } from "@vercel/speed-insights/react"

export const config = createConfig(
  getDefaultConfig({
    // Your dApps chains
    chains: [base],
    connectors:[injected()],
    transports: {
      [base.id]: http(`https://base-mainnet.g.alchemy.com/v2/${process.env.REACT_APP_ALCHEMY_API_KEY}`),
    },

    // Required API Keys
    walletConnectProjectId: process.env.REACT_APP_WALLETCONNECT_PROJECT_ID,

    // Required App Info
    appName: "Merge.markets",

    // Optional App Info
    appDescription: "Merging is fun",
    appUrl: "", // your app's url
    appIcon: "" // your app's icon, no bigger than 1024x1024px (max. 1MB)
  }),
);

const queryClient = new QueryClient()

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);


root.render(<BrowserRouter>
<WagmiProvider config={config}>
<QueryClientProvider client={queryClient}>
<ConnectKitProvider>
  <WalletProvider>
    <VisionUIControllerProvider>
      <ToastContainer position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={true}/>
        <App />
    </VisionUIControllerProvider>
  </WalletProvider>
  </ConnectKitProvider>
  </QueryClientProvider>
  </WagmiProvider>
</BrowserRouter>)

